import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Plus from "assets/icons/Plus";
import { useTranslation } from "react-i18next";
const InviteUser = ({ inviteUserHandler, branchDataStatus,activeTab }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleClick = () => {
    if (branchDataStatus || !inviteUserHandler) navigate(`/user-management/add-user?${activeTab}`);
    else inviteUserHandler();
  };

  return (
    <button className="parentbtn" onClick={handleClick}>
      <Plus style={{ fill: "white" }} width={15} />
      &nbsp;&nbsp;{t("invite-user")}
    </button>
  );
};

export default InviteUser;
